import React from 'react'
import HorizontalTabs from '../components/HorizontalTabs';
import { Link } from 'react-router-dom';



function schooltrips() {

  const tabs = [

                { title: 'Educational Trip (Germany- SCORA MEET)', content: () => <div>

                  <div className='cam-lower-sec'>
                     <h1 className='title'>Educational Trip (Germany- SCORA MEET)</h1>
                  </div>
              
                  <div className='photo-sec'>
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Germany- SCORA MEET/img-01.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Germany- SCORA MEET/img-01.jpeg'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Germany- SCORA MEET/img-02.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Germany- SCORA MEET/img-02.jpeg'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Germany- SCORA MEET/img-03.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Germany- SCORA MEET/img-03.jpeg'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Germany- SCORA MEET/img-04.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Germany- SCORA MEET/img-04.jpeg'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Germany- SCORA MEET/img-05.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Germany- SCORA MEET/img-05.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Germany- SCORA MEET/img-06.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Germany- SCORA MEET/img-06.jpeg'></img>
                      </Link>
                    </div>
                 
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Germany- SCORA MEET/img-07.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Germany- SCORA MEET/img-07.jpeg'></img>
                      </Link>
                    </div>

                    <div className='photo-box'>
                    <Link to="../img/School Trip/Germany- SCORA MEET/img-08.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Germany- SCORA MEET/img-08.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Germany- SCORA MEET/img-09.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Germany- SCORA MEET/img-09.jpeg'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Germany- SCORA MEET/img-10.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Germany- SCORA MEET/img-10.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Germany- SCORA MEET/img-11.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Germany- SCORA MEET/img-11.jpeg'></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Germany- SCORA MEET/img-12.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Germany- SCORA MEET/img-12.jpeg'></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Germany- SCORA MEET/img-13.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Germany- SCORA MEET/img-13.jpeg'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Germany- SCORA MEET/img-14.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Germany- SCORA MEET/img-14.jpeg'></img>
                      </Link>
                    </div>
                    
                   
               

               
                   
             
               
               
              
                    </div>
                    </div>
                },
                { title: 'Educational Trip (JIM CORBETT NATIONAL PARK)', content: () => <div>

                  <div className='cam-lower-sec'>
                     <h1 className='title'>Educational Trip (Goa)</h1>
                  </div>
              
                  <div className='photo-sec'>
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-01.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-01.jpeg'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-02.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-02.jpeg'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-03.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-03.jpeg'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-04.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-04.jpeg'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-05.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-05.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-06.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-06.jpeg'></img>
                      </Link>
                    </div>
                 
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-07.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-07.jpeg'></img>
                      </Link>
                    </div>

                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-08.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-08.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-09.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-09.jpeg'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-10.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-10.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-11.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-11.jpeg'></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-12.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-12.jpeg'></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-13.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-13.jpeg'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-14.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-14.jpeg'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-15.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-15.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-16.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-16.jpeg'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-17.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-17.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-18.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-18.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-19.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-19.jpeg'></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-20.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-20.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-21.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-21.jpeg'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-22.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-22.jpeg'></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-23.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-23.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-24.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-24.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-25.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-25.jpeg'></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-26.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-26.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-27.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-27.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-28.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-28.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-29.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-29.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Goa/img-30.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Goa/img-30.jpeg'></img>
                      </Link>
                    </div>
               
               

               
                   
             
               
               
              
                    </div>
                    </div>
                },
                { title: 'Educational Trip (Goa)', content: () => <div>

                  <div className='cam-lower-sec'>
                     <h1 className='title'>Educational Trip (JIM CORBETT NATIONAL PARK)</h1>
                  </div>
              
                  <div className='photo-sec'>
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-01.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-01.jpeg'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-02.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-02.jpeg'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-03.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-03.jpeg'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-04.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-04.jpeg'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-05.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-05.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-06.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-06.jpeg'></img>
                      </Link>
                    </div>
                 
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-07.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-07.jpeg'></img>
                      </Link>
                    </div>

                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-08.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-08.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-09.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-09.jpeg'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-10.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-10.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-11.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-11.jpeg'></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-12.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-12.jpeg'></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-13.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-13.jpeg'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-14.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-14.jpeg'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-15.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-15.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-16.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-16.jpeg'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-17.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-17.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-18.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-18.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-19.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-19.jpeg'></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-20.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-20.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-21.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-21.jpeg'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-22.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-22.jpeg'></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-23.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-23.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-24.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-24.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-25.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-25.jpeg'></img>
                      </Link>
                    </div>
                  
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-26.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-26.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-27.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-27.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-28.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-28.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-29.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-29.jpeg'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Jim Corbett National Park/img-30.jpeg"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Jim Corbett National Park/img-30.jpeg'></img>
                      </Link>
                    </div>
               
               

               
                   
             
               
               
              
                    </div>
                    </div>
                },
                { title: 'Educational Trip (Singapore)', content: () => <div>

                  <div className='cam-lower-sec'>
                     <h1 className='title'>Educational Trip (Singapore)</h1>
                  </div>
              
                  <div className='photo-sec'>
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore-1.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore-1.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore-4.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore-4.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore-5.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore-5.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore-6.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore-6.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore-7.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore-7.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -8.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -8.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -9.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -9.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -10.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -10.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -11.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -11.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -12.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -12.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -13.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -13.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -14.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -14.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -15.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -15.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -16.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -16.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -17.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -17.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -18.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -18.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -19.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -19.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -20.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -20.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -21.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -21.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -22.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -22.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -23.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -23.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -24.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -24.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -25.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -25.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -26.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -26.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -27.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -27.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -28.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -28.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -29.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -29.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -30.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -30.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -31.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -31.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -32.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -32.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -33.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -33.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -34.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -34.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -35.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -35.webp'></img>
                      </Link>
                    </div>
               
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -36.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -36.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -37.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -37.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -38.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -38.webp'></img>
                      </Link>
                    </div>
               
                     
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -39.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -39.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -40.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -40.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -41.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -41.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -42.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -42.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -43.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -43.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -44.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -44.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -45.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -45.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -46.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -46.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -47.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -47.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -48.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -48.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -49.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -49.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -50.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -50.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -51.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -51.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -52.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -52.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -53.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -53.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -54.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -54.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -55.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -55.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -56.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -56.webp'></img>
                      </Link>
                    </div>
               
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Singapore/Singapore -57.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Singapore/Singapore -57.webp'></img>
                      </Link>
                    </div>
                    </div>
                    </div>
                },
                { title: 'Educational Trip (Manali)', content: () => <div>

                  <div className='cam-lower-sec'>
                     <h1 className='title'>Educational Trip (Manali)</h1>
                  </div>
              
                  <div className='photo-sec'>
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Manali/Manali trip_1.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Manali/Manali trip_1.webp'></img>
                      </Link>
                    </div>
                 
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Manali/Manali trip_2.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Manali/Manali trip_2.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Manali/Manali trip_3.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Manali/Manali trip_3.webp'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Manali/Manali trip_4.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Manali/Manali trip_4.webp'></img>
                      </Link>
                    </div>

                    <div className='photo-box'>
                    <Link to="../img/School Trip/Manali/Manali trip_5.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Manali/Manali trip_5.webp'></img>
                      </Link>
                    </div>

                    <div className='photo-box'>
                    <Link to="../img/School Trip/Manali/Manali trip_6.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Manali/Manali trip_6.webp'></img>
                      </Link>
                    </div>

                    <div className='photo-box'>
                    <Link to="../img/School Trip/Manali/Manali trip_7.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Manali/Manali trip_7.webp'></img>
                      </Link>
                    </div>

                    <div className='photo-box'>
                    <Link to="../img/School Trip/Manali/Manali trip_8.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Manali/Manali trip_8.webp'></img>
                      </Link>
                    </div>

                    <div className='photo-box'>
                    <Link to="../img/School Trip/Manali/Manali trip_9.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Manali/Manali trip_9.webp'></img>
                      </Link>
                    </div>

                    <div className='photo-box'>
                    <Link to="../img/School Trip/Manali/Manali trip_10.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Manali/Manali trip_10.webp'></img>
                      </Link>
                    </div>
                    <div className='photo-box'>
                    <Link to="../img/School Trip/Manali/Manali trip_11.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/Manali/Manali trip_11.webp'></img>
                      </Link>
                    </div>
                    </div>
                    </div>
            },
                { title: 'Educational Trip (Nainital)', content: () => <div>

                  <div className='cam-lower-sec'>
                     <h1 className='title'>Educational Trip (Nainital)</h1>
                  </div>
              
                  <div className='photo-sec'>
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial01.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial01.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial09.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial09.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial10.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial10.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial11.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial11.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial12.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial12.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial13.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial13.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial14.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial14.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial15.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial15.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial16.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial16.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial17.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial17.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial18.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial18.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial19.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial19.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial20.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial20.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial21.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial21.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial22.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial22.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial23.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial23.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial24.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial24.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial25.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial25.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial26.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial26.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial27.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial27.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial28.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial28.webp'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial29.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial29.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial30.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial30.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial31.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial31.webp'></img>
                      </Link>
                    </div>
                 
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial32.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial32.webp'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial33.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial33.webp'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/nainital/nainial34.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/nainital/nainial34.webp'></img>
                      </Link>
                    </div>
                
                    </div>
                    </div>
            },
                { title: 'Educational Trip (Pushkar)', content: () => <div>

                  <div className='cam-lower-sec'>
                     <h1 className='title'>Educational Trip (Pushkar)</h1>
                  </div>
              
                  <div className='photo-sec'>
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar01.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar01.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar02.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar02.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar03.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar03.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar04.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar04.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar05.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar05.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar06.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar06.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar07.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar07.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar08.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar08.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar09.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar09.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar10.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar10.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar11.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar11.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar12.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar12.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar13.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar13.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar14.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar14.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar15.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar15.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar16.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar16.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar17.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar17.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar18.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar18.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar19.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar19.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar20.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar20.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar21.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar21.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar22.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar22.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar23.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar23.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar24.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar24.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar25.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar25.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar26.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar26.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar27.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar27.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar28.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar28.webp'></img>
                      </Link>
                    </div>
                   
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar29.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar29.webp'></img>
                      </Link>
                    </div>
                    
                    <div className='photo-box'>
                    <Link to="../img/School Trip/pushkar/pushkar30.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/pushkar/pushkar30.webp'></img>
                      </Link>
                    </div>

                
                    </div>
                    </div>
            },
                { title: 'Educational Trip (Chandigarh)', content: () => <div>

                  <div className='cam-lower-sec'>
                     <h1 className='title'>Educational Trip (Chandigarh)</h1>
                  </div>
              
                  <div className='photo-sec'>
                    <div className='photo-box'>
                    <Link to="../img/School Trip/chandigarh/chandigarh01.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/chandigarh/chandigarh01.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/School Trip/chandigarh/chandigarh02.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/chandigarh/chandigarh02.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/School Trip/chandigarh/chandigarh03.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/chandigarh/chandigarh03.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/School Trip/chandigarh/chandigarh04.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/chandigarh/chandigarh04.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/School Trip/chandigarh/chandigarh05.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/chandigarh/chandigarh05.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/School Trip/chandigarh/chandigarh06.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/chandigarh/chandigarh06.webp'></img>
                      </Link>
                    </div>
                
                    <div className='photo-box'>
                    <Link to="../img/School Trip/chandigarh/chandigarh11.webp"
                        target="_blank"
                        rel="noopener noreferrer">
                       <img src='../img/School Trip/chandigarh/chandigarh11.webp'></img>
                      </Link>
                    </div>
                
                
                    </div>
                    </div>
            },
          ]

  return (
     <div>
    <div className='ibdp-hero-sec'>
       <img src='newimg/Singapore -11 (3).webp'/>

     </div>
     <div className="newsletter-sec">
     <HorizontalTabs tabs={tabs} />
     </div>


   </div> 
  )
}

export default schooltrips
